import React from 'react';
import { connect } from 'react-redux';
import { useParams } from 'react-router-dom';
import { styled } from '@erecruit/ui-kit';
import { Notes } from '@erecruit/modules';
import { AboutTypes, AppPermissions } from '@erecruit/types';

import { RootState } from '../../../redux/reducers';
import { getUserName } from '../../../App/selectors';

const NotesContainer = styled.div({
  padding: '0 20%',
});

export interface MatchNotesProps {
  userName?: string;
}

const MatchNotes = ({ userName }: MatchNotesProps) => {
  const { id: matchId } = useParams<{ id: string }>();

  return (
    <NotesContainer>
      <Notes
        type={AboutTypes.Match}
        referenceId={Number(matchId)}
        userName={userName}
        editPermission={AppPermissions.EditMatchNotes}
      />
    </NotesContainer>
  );
};

export default connect(
  (state: RootState) => ({
    userName: getUserName(state),
  }),
  {},
)(MatchNotes);
